<template>
  <div class="content">
    <el-dialog v-bind="$attrs" v-on="$listeners" @open="onOpen" title="编辑">
      <el-form
        ref="modifyRef"
        :model="authority"
        :rules="rules"
        size="medium"
        label-width="100px"
      >
      <el-row :gutter="15">
          <el-col :span="12">
            <el-form-item label="名称" prop="name">
              <el-input
                v-model="authority.name"
                clearable
                :style="{ width: '100%' }"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="编码" prop="code">
              <el-input
                v-model="authority.code"
                clearable
                :style="{ width: '100%' }"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :span="12">
            <el-form-item label="描述" prop="description">
              <el-input
                v-model="authority.description"
                clearable
                :style="{ width: '100%' }"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="菜单PID" prop="menuPid">
              <el-select
                v-model="authority.menuPid"
                placeholder="请选择pid"
                :disabled="isDisabled"
              >
                <el-option
                  v-for="element in pidSelect"
                  :key="element.label"
                  :label="element.label"
                  :value="element.value"
                ></el-option>
              </el-select>
              <!-- <el-input
                v-model="authority.pid"
                clearable
                :style="{ width: '100%' }"
              ></el-input> -->
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :span="12">
            <el-form-item label="类型"  prop="type">
              <el-select
                v-model="authority.type"
                placeholder="请选择权限类型"
                @change="handleChange"
              >
                <el-option
                  v-for="element in typeSelect"
                  :key="element.label"
                  :label="element.label"
                  :value="element.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="状态"  prop="enVisible">
              <el-select
                v-model="authority.enVisible"
                placeholder="请选择可见状态"
              >
                <el-option
                  v-for="element in enVisibleSelect"
                  :key="element.label"
                  :label="element.label"
                  :value="element.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        
        <!-- 菜单字段 -->
        <div v-if="typeNumflag == 1">
          <el-row :gutter="15">
            <el-col :span="12">
              <el-form-item label="菜单名称"  prop="menuName">
                <el-input
                  v-model="authority.menuName"
                  clearable
                  :style="{ width: '100%' }"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="icon"  prop="menuIcon">
                <el-input
                  v-model="authority.menuIcon"
                  clearable
                  :style="{ width: '100%' }"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="15">
            <el-col :span="12">
              <el-form-item label="菜单路由"  prop="menuUrl">
                <el-input
                  v-model="authority.menuUrl"
                  clearable
                  :style="{ width: '100%' }"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="菜单组件"  prop="menuComponent">
                <el-input
                  v-model="authority.menuComponent"
                  clearable
                  :style="{ width: '100%' }"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="15">
            <el-col :span="12">
              <el-form-item label="tableTitle"  prop="menuTableTitle">
                <el-input
                  v-model="authority.menuTableTitle"
                  clearable
                  :style="{ width: '100%' }"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="重定向地址"  prop="menuRedirectUrl">
                <el-input
                  v-model="authority.menuRedirectUrl"
                  clearable
                  :style="{ width: '100%' }"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <!-- 功能字段 -->
        <div v-if="typeNumflag == 2">
          <el-row :gutter="15">
            <el-col :span="12">
              <el-form-item label="功能代码"  prop="pointClass">
                <el-input
                  v-model="authority.pointClass"
                  clearable
                  :style="{ width: '100%' }"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="功能图标"  prop="pointIcon">
                <el-input
                  v-model="authority.pointIcon"
                  clearable
                  :style="{ width: '100%' }"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="15">
            <el-col :span="12">
              <el-form-item label="功能状态"  prop="pointStatus">
                <el-select
                  v-model="authority.pointStatus"
                  placeholder="请选择功能状态"
                >
                  <el-option
                    v-for="element in pointStatusSelect"
                    :key="element.label"
                    :label="element.label"
                    :value="element.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <!-- 接口字段 -->
        <div v-if="typeNumflag == 3">
          <el-row :gutter="15">
            <el-col :span="12">
              <el-form-item label="接口链接"  prop="apiUrl">
                <el-input
                  v-model="authority.apiUrl"
                  clearable
                  :style="{ width: '100%' }"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="请求类型"  prop="apiMethod">
                <el-select
                v-model="authority.apiMethod"
                placeholder="请选择请求类型"
              >
                <el-option
                  v-for="element in requestTypeSelect"
                  :key="element.label"
                  :label="element.label"
                  :value="element.value"
                ></el-option>
              </el-select>
                <!-- <el-input
                  v-model="authority.apiMethod"
                  clearable
                  :style="{ width: '100%' }"
                ></el-input> -->
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="15">
            <el-col :span="12">
              <el-form-item label="权限等级"  prop="apiLevel">
                <el-select
                  v-model="authority.apiLevel"
                  placeholder="请选择权限等级"
                >
                  <el-option
                    v-for="element in apiLevelSelect"
                    :key="element.label"
                    :label="element.label"
                    :value="element.value"
                  ></el-option>
                </el-select>
                <!-- <el-input
                  v-model="authority.apiLevel"
                  clearable
                  :style="{ width: '100%' }"
                ></el-input> -->
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>

      <div slot="footer" v-if="true">
        <el-button @click="close">取消</el-button>
        <el-button type="primary" @click="handelConfirm">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { editPermissionInfo ,addPermission ,getPermissionMenuList}  from '@/api/systemData'


export default {
  props: ["data","typeNum"],
  data() {
    return {
      typeNumflag:"",  //选择类型，判断显示对应的字段  1，菜单  2，功能  3，API接口
      pidSelect:[], //可选择的父权限->针对的是菜单设置
      isDisabled: true,
      //权限类型
      typeSelect:[
        {
          "label":"菜单",
          "value":1
        },
        {
          "label":"功能",
          "value":2
        },
        {
          "label":"API接口",
          "value":3
        },
      ],
      //可见状态 0不可见1可见
      enVisibleSelect:[
        {
          "label":"可见",
          "value":1
        },
        {
          "label":"不可见",
          "value":0
        }
      ],
      //请求类型
      apiLevelSelect:[
        {
          "label":"get",
          "value":"get"
        },
        {
          "label":"post",
          "value":"post"
        },
        {
          "label":"put",
          "value":"put"
        },
        {
          "label":"delete",
          "value":"delete"
        },
      ],
      
      //权限等级
      requestTypeSelect:[
        {
          "label":"通用接口",
          "value":"1"
        },
        {
          "label":"校验接口",
          "value":"2"
        }
      ],
      //功能状态
      pointStatusSelect:[
      {
          "label":"可用",
          "value":"0"
        },
        {
          "label":"不可用",
          "value":"1"
        }
      ],
      authority: {
        id:"",
        pid:"",
        name: "",
        type: "",
        code: "",
        menuPid: "",
        description: "",  //菜单的PID 
        enVisible: "",
        // 菜单字段
        menuName:"",  //菜单名称
        menuIcon:"",  //菜单图标
        menuUrl:"",  //路由
        menuComponent:"",  //组件
        menuTableTitle:"",  //菜单标题
        menuRedirectUrl:"",  //重定向地址
        //功能
        pointClass:"",//权限代码
        pointIcon:"",//图标
        pointStatus:"",//状态
        //API接口
        apiUrl:"",  //接口链接
        apiMethod:"",  //请求类型
        apiLevel:"",  //权限等级，1为通用接口权限，2为需校验接口权限
      },
      rules: {
        name: [
          {
            required: true,
            message: "名称不能为空",
            trigger: "blur",
          },
        ],
        type: [
          {
            required: true,
            message: "类型不能为空",
            trigger: "blur",
          },
        ],
        code: [
          {
            required: true,
            message: "编码不能为空",
            trigger: "blur",
          },
        ],
        description: [
          {
            required: true,
            message: "描述不能为空",
            trigger: "blur",
          },
        ],
        menuPid: [
          {
            required: false,
            message: "父id不能为空",
            trigger: "blur",
          },
        ],
        enVisible: [
          {
            required: true,
            message: "可见状态不能为空",
            trigger: "blur",
          },
        ],
      },
      systemList: [],
    };
  },
  computed: {},
  watch: {
    typeNum:{
      handler(newData) {
        this.typeNumflag = newData
        if (newData == 1) {
          this.isDisabled = false
          this.rules.menuName=  [{required:true,message: "菜单名称不能为空",trigger: "blur",}]
          this.rules.menuIcon=  [{required:false,message: "菜单图标不能为空",trigger: "blur",}]
          this.rules.menuUrl=  [{required:true,message: "菜单路由不能为空",trigger: "blur",}]
          this.rules.menuComponent=  [{required:true,message: "菜单组件不能为空",trigger: "blur",}]
          this.rules.menuTableTitle=  [{required:false,message: "菜单标题名称不能为空",trigger: "blur",}]
          this.rules.menuRedirectUrl=  [{required:false,message: "菜单重定向地址不能为空",trigger: "blur",}]
        }else if(newData == 2){
          this.isDisabled = true

        }else if(newData == 3){
          this.isDisabled = true

        }
      },
      
    },
    data: {
      deep: true,
      handler(newData) {
        this.authority = {
          ...newData,
        };
      },
    },
  },
  created() {
    this.getMenuPermissionList();
  },
  mounted() {},
  methods: {
    handleChange(value) {
      console.log("value",value);
      this.typeNumFlag = value;
      if(value == 1){
        this.isDisabled = false
      }
      // this.$set(this.validations(), 'menuName', { required: true, menuName: true }); 
      // this.$nextTick(() => {
      //   this.$refs["addRef"].resetValidation(); // 使用resetValidation来重置表单验证状态
      // });

    },
    //获取权限(菜单)列表
    getMenuPermissionList(){
      console.log("获取menu");
      getPermissionMenuList().then((res)=>{
        if(res.code == 10000){
          this.pidSelect = [];
          if(res.data != null && res.data.length > 0){
            console.log("res.data",res.data);
            let resultMunuList = res.data;
            for(let i=0;i<resultMunuList.length;i++){
              let obj={};
              obj.label = resultMunuList[i].name;
              obj.value = resultMunuList[i].pid;
              this.pidSelect.push(obj);
            }
          }
        }
      })
    },
    onOpen() {},
    onClose() {
      this.$refs["modifyRef"].resetFields();  //清空表单数据
    },
    close() {
      this.$emit("update:visible", false);
    },
    handelConfirm() {
      console.log("edit=====");
      this.$refs["modifyRef"].validate((valid) => {
        if (valid) {
          //处理修改的逻辑
          console.log("this.authority",this.authority);
          // return;
          // this.authority = {
          //   "name":11
          // }
          // return ;
          editPermissionInfo(this.authority).then((res) => {
            if (res.code == 10000) {
              this.$message.success("编辑成功");
              this.close();
              // this.onClose();
              this.$emit("edit-success");
            }
          });
        }
      });
    },
    
  },
};
</script>
<style lang="less" scoped>
.content {
  background-color: #fff;
  padding: 10px;
}
::v-deep .el-transfer-panel {
  border: 1px solid #e6ebf5;
  border-radius: 4px;
  overflow: hidden;
  background: #ffffff;
  display: inline-block;
  vertical-align: middle;
  width: 200px;
  max-height: 100%;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  position: relative;
  width: 341px;
}
::v-deep .el-dialog {
  -webkit-transform: none;
  transform: none;
  left: 0;
  position: relative;
  margin: 0 auto;
  width: 1000px;
}
::v-deep .el-transfer-panel__body {
  height: 330px;
}
::v-deep .el-transfer-panel__list.is-filterable {
  height: 278px;
  padding-top: 0;
}
</style>
